import Api from '@/services/Api'

export default class {
  getBilling() {
    return Api().get('user/billing')
  }
  saveBilling(billingInfo) {
    let formData = new FormData();
    formData.append('tokenID', billingInfo.tokenID);
    formData.append('address1', billingInfo.address1);
    formData.append('address2', billingInfo.address2);
    formData.append('city', billingInfo.city);
    formData.append('postCode', billingInfo.postCode);
    return Api().post('user/billing', formData)
  }

  removeBilling() {
    return Api().delete('user/billing')
  }

  subscribe(subscribeInfo) {
    let formData = new FormData()
    formData.append('deviceID', subscribeInfo.ID)
    return Api().post('user/billing/subscription', formData)
  }

  cancelSubscribtion(subscription) {
    return Api().delete('user/billing/subscription/' + subscription.ID)
  }

  enableAutoRenew(subscription) {
    return Api().get('user/billing/subscription/' + subscription.ID + '/autorenew/enable')
  }

  disableAutoRenew(subscription) {
    return Api().get('user/billing/subscription/' + subscription.ID + '/autorenew/disable')
  }

  addCard(token) {
    let formData = new FormData()
    formData.append('token', token)
    return Api().post('user/billing/add-card', formData)
  }

  // registerEmail (code, email) {
  //     let formData = new FormData();
  //     formData.append('code', code);
  //     formData.append('email', email);
  //     return Api().post('register', formData)
  // }

}
